import { render, staticRenderFns } from "./SelectPackagesMultiDialog.vue?vue&type=template&id=7b67ca70&scoped=true"
import script from "./SelectPackagesMultiDialog.vue?vue&type=script&lang=js"
export * from "./SelectPackagesMultiDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b67ca70",
  null
  
)

export default component.exports